import {
  IAdaptiveService,
  MOBILE_SCREEN,
  TypeDevice,
} from '../../types/features/adaptive/adaptive-types';

class AdaptiveService implements IAdaptiveService {
  private typeDevice: TypeDevice = 'dekstop';

  constructor() {
    if (window.innerWidth <= MOBILE_SCREEN) {
      this.typeDevice = 'mobile';
    }
  }

  getTypeDevice() {
    return this.typeDevice;
  }
}

export { AdaptiveService };
